// Mock authentication service that works without backend
export interface LoginRequest {
  email: string;
  password: string;
}

export interface LoginResponse {
  message: string;
  user: {
    id: string;
    email: string;
    fullName: string;
    phone: string | null;
    role: string;
    status: string;
    emailVerified: boolean;
    phoneVerified: boolean;
    lastLoginAt: string;
    createdAt: string;
    updatedAt: string;
  };
  accessToken: string;
  refreshToken: string;
}

class MockAuthAPIService {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500));
    
    // Check credentials
    if (credentials.email === 'admin@polarride.com' && credentials.password === 'PolarRide2024!Admin') {
      return {
        message: "Login successful",
        user: {
          id: "1",
          email: "admin@polarride.com",
          fullName: "Admin User",
          phone: "+234 801 234 5678",
          role: "admin",
          status: "active",
          emailVerified: true,
          phoneVerified: true,
          lastLoginAt: new Date().toISOString(),
          createdAt: "2024-01-01T00:00:00Z",
          updatedAt: new Date().toISOString()
        },
        accessToken: "mock-token-" + Date.now(),
        refreshToken: "mock-refresh-" + Date.now()
      };
    } else {
      throw new Error('Invalid credentials');
    }
  }

  async logout(): Promise<void> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 200));
    // Clear local storage
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
  }

  async refreshToken(refreshToken: string): Promise<{ accessToken: string; refreshToken: string }> {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 300));
    
    return {
      accessToken: "mock-token-" + Date.now(),
      refreshToken: "mock-refresh-" + Date.now()
    };
  }

  async getCurrentUser(): Promise<any> {
    const token = localStorage.getItem('token');
    
    if (!token) {
      throw new Error('No auth token');
    }

    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 200));

    return {
      id: "1",
      email: "admin@polarride.com",
      fullName: "Admin User",
      phone: "+234 801 234 5678",
      role: "admin",
      status: "active",
      emailVerified: true,
      phoneVerified: true,
      createdAt: "2024-01-01T00:00:00Z",
      updatedAt: new Date().toISOString()
    };
  }
}

export const mockAuthAPI = new MockAuthAPIService();